import tree from '@/components/tree.vue'
import { dwgl } from '@/axios'
import Page from '@/components/page.vue'
import DelData from '@/components/delToast.vue'
import { Message } from 'element-ui'
import myTables from '@/components/tables/tables.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				page:1,
				year:"",
				month:""
			},
			delList:[],
			tableHeader: [     // 表头
				{prop: 'title', label: '标题'},
				{prop: 'pub_user', label: '党组织',width:"160"},
				{prop: 'day', label: '时间',width:'110'},
				{prop: 'class_name', label: '分类',width:'110'},
				// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '120',
					oper: [
						{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
						{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
						{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
			tableData:[],
			totalPage:0
		}
	},
	components:{tree,Page,DelData,myTables},
	mounted() {
		that.dataList();
	},
	created() {
		that = this;
	},
	methods:{
		// 数据
		dataList(){
			dwgl.partyAffairsList(that.getdata).then(res => {
				that.tableData = res.data.pagedata;
				that.totalPage = res.data.count;
			})
		},
		// 详情
		showDetail(data){
			that.$router.push({
				path:"/dwgk_detail",
				query:{
					flag:that.getdata.flag,
					id:data.id,
					userId:that.getdata.user_d
				}
			})
		},
		// 编辑
		edit(data){
			that.$router.push({
				path:"/dwgk_add",
				query:{
					type:'edit',
					id:data.id
				}
			})
		},
		// 新增
		addZx(){
			that.$router.push({
				path:'/dwgk_add',
				query:{
					type:'add'
				},
			})
		},
		// 一键删除
		selectList(value){
			that.delList = value;
		},
		delAll(){
			if(that.delList.length == 0){
				Message.warning('请先选择要删除得数据')
			}else{
				that.delData();
			}
		},
		//	删除操作
		delData(){
			that.$refs.delDatas.showToast(res => {
				if(res){
					dwgl.delPartyAffairs({
						id:that.delList,
					}).then(res => {
						if(res.code == 200){
							Message({
								type: 'success',
								message: '删除成功!'
							})
						}else{
							Message({
								type: 'error',
								message: res.msg
							})
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}
			})
		},
		// 删除
		del(data){
			that.delList = [];
			that.delList = [data.id];
			that.delData();
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.user_id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.page = 1;
			that.dataList();
		},
		// 分页筛选
		changedata(curret){
			that.getdata.page = curret;
			that.dataList();
		},
	}
}